<template>
  <div class="todoItem">
    <div class="checkboxContainer" :class="{ checked: todoItem.checked }">
      <debug style="float: right" :object="todoItem" />
      <input class="customCheckbox" :id="todoItem._id" type="checkbox" v-model="checked" @click="playSound" />

      <label class="customCheckboxLabel" :for="todoItem._id">
        <span class="strikethrough" />
        <textarea
          :style="{ color: todoItem.colour }"
          class="title"
          rows="1"
          ref="title"
          @blur="updateSimpleProperty('title', $event.target.value)"
          @keyup.enter="updateSimpleProperty('title', $event.target.value)"
          :readonly="!editable"
          :value="todoItem.title"
          @dblclick="editable = true"
        />
      </label>
      <small v-if="todoItem.checked">
        {{ $t('Checked {date} by {name}', { date: checkedDate, name: personName(todoItem.checkedBy) }) }}
      </small>
    </div>
  </div>
</template>
<script>
import { recentFuzzytime } from '@/common/timeHelpers';
import { mapActions, mapGetters } from 'vuex';
import autosize from 'autosize';

export default {
  name: 'TodoItem',
  props: ['todoItem'],
  data: function () {
    return {
      editable: false,
    };
  },
  methods: {
    ...mapActions(['saveTodoItemProperties']),
    updateSimpleProperty: function (property, newValue) {
      var newTodoItemProperties = {};
      newTodoItemProperties[property] = newValue;
      this.saveTodoItemProperties({
        updateTodoItem: this.todoItem,
        newTodoItemProperties: newTodoItemProperties,
      });
      this.editable = false;
    },
    playSound: function (event) {
      var checked = event.target.checked;
      var audio = new Audio('/static/BOON_control_fulfilled.wav');

      if (checked === true) {
        audio.play();
      }
    },
  },
  computed: {
    ...mapGetters(['personName']),
    checked: {
      get: function () {
        return this.todoItem.checked;
      },
      set: function (newValue) {
        this.saveTodoItemProperties({ updateTodoItem: this.todoItem, newTodoItemProperties: { checked: newValue } });
      },
    },
    checkedDate: function () {
      return recentFuzzytime(this.todoItem.checkedAt);
    },
  },
  filters: {},
  components: {},
  mounted: function () {
    autosize(this.$refs['title']);
  },
};
</script>

<style scoped>
.todoItem {
  display: block;
  margin-left: 10px;
  margin-bottom: 5px;
}

.todoItem small {
  display: block;
  margin-bottom: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 80%;
}
.strikethrough {
  display: none;
  position: absolute;
  top: 10px;
  left: 0px;
  width: 100%;
  height: 2px;
  background-color: black;
}

.checked .strikethrough {
  display: block;
  animation-name: strikethrough;
  animation-duration: 1000ms;
  animation-timing-function: ease-out;
  animation-iteration-count: 1;
}

textarea {
  width: 100%;
  background: inherit;
}
input[type='text']:read-only {
  color: black;
}
.checkboxContainer {
  white-space: nowrap;
}

.customCheckbox + label {
  display: block;
  width: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// src/components/projectplan/TodoItem.vue